import { render, staticRenderFns } from "./TrigeminalBlock.vue?vue&type=template&id=55c2f157&scoped=true"
import script from "./TrigeminalBlock.vue?vue&type=script&lang=js"
export * from "./TrigeminalBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2f157",
  null
  
)

export default component.exports